export default __webpack_public_path__ + "static/media/Left.92b9faa1.svg";